<template>
  <div class="ui-block">
    <span v-for="(cta, idx) in components" :key="idx" class="ui-cta" @click="() => cta.action()">
      <i :class="[`icon-${cta.icon}`]" />
    </span>
  </div>
</template>

<script>
export default {
  props: ['data'],

  computed: {
    components() {
      return this.data.components;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
.ui-block {
  flex: 0.5;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ui-cta {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 22px;
  height: 22px;
  box-sizing: border-box;
  border: 1px solid #bc141a;
  color: #bc141a;
  border-radius: 50%;
  transition: all 0.3s ease;
  background-color: rgba(#bc141a, 0);
  cursor: pointer;

  &:hover {
    background-color: #bc141a;
    color: #ffffff;
  }
}
.icon-closethin {
  display: flex;
  transform: rotate(45deg);
}
</style>
